import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ChangePasswordType } from "../schema/ChangePasswordSchema";
import { ChangePasswordResponse } from "../response/ChangePasswordResponse";
import { ValidationUpdateResponse } from "../response/ValidationUpdateResponse";

export const useChangePassword = () => {
    return useMutation({
        mutationFn: async (formData: ChangePasswordType) => privateApi.put(`/v4/change-password`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = ChangePasswordResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid password data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update password', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationUpdateResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid password data format");
            } else {
                console.error('Failed to update password', error);
                throw error;
            }
        },
    });
};